export default {
  rows: 'Lines',
  separator: 'from',
  selected: 'selected'
}



// WEBPACK FOOTER //
// ./src/i18n/en/pagination.js